/**
 * The open editor tab's accent. Step cards inside pick it up unless a card
 * names its own tone.
 * For Media Devoted | Created By Ciro Autiero
 */
import { createContext, FC, ReactNode, useContext } from 'react';

import type { StepTone } from './step-tone';

const StepToneContext = createContext<StepTone | undefined>(undefined);

export const StepToneProvider: FC<{ tone: StepTone; children: ReactNode }> = ({ tone, children }) => (
  <StepToneContext.Provider value={tone}>{children}</StepToneContext.Provider>
);

export function useOptionalStepTone(): StepTone | undefined {
  return useContext(StepToneContext);
}
